export const objectSchemas = objects => objects
    .filter(object => object.schema)
    .reduce((allSchemas, object) => ({
        ...allSchemas,
        [object.name]: object.schema,
    }), {});

export const objectSerializers = objects => objects
    .filter(object => object.toMarkdown)
    .reduce((allSerializers, object) => ({
        ...allSerializers,
        [object.name]: object.toMarkdown,
    }), {});

export const objectParsers = objects => objects
    .filter(object => object.parseMarkdown)
    .reduce((allParsers, object) => ({
        ...allParsers,
        [object.markdownToken || object.name]: object.parseMarkdown,
    }), {});

export const objectKeyMaps = (objects, schema) => objects
    .filter(object => object.keys)
    .map(object => object.keys({
        type: schema[`${object.type}s`][object.name],
        schema,
    }));

export const objectInputRules = (objects, schema) => objects
    .filter(object => object.inputRules)
    .flatMap(object => object.inputRules({
        type: schema[`${object.type}s`][object.name],
        schema
    }));

export const objectCommands = (objects, view) => objects
    .filter(object => object.commands)
    .reduce((allCommands, object) => {
        const {name, type} = object;
        const commands = {};
        const value = object.commands({
            schema: view.state.schema,
            ...{
                type: view.state.schema[`${type}s`][name]
            }
        });

        const apply = (callback, attrs) => {
            if (!view.editable) {
                return false;
            }
            view.focus();
            return callback(attrs)(view);
        };

        const handle = (_name, _value) => {
            if (Array.isArray(_value)) {
                commands[_name] = attrs => _value.forEach(callback => apply(callback, attrs));
            } else if (typeof _value === "function") {
                commands[_name] = attrs => apply(_value, attrs);
            }
        };

        if (typeof value === "object") {
            Object.entries(value).forEach(([commandName, commandValue]) => handle(commandName, commandValue));
        } else {
            handle(name, value);
        }

        return {
            ...allCommands,
            ...commands,
        };
    }, {});